module.exports = __webpack_public_path__ + "img/mapLong_large.1a111a4b.png";